import React from "react";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";

type Props = {
  label?: string;
  primaryColor?: string;
  horizontalPaddingPx?: number;
  topRightRadius?: string;
  invisible?: boolean;
};

export function RecommendedVehicleBanner({
  label,
  primaryColor = "#2cb133",
  horizontalPaddingPx = 16,
  topRightRadius = "0px",
  invisible = false,
}: Props) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        margin: `-8px -${horizontalPaddingPx}px 12px`,
        padding: "10px 16px",
        backgroundColor: primaryColor,
        color: "#ffffff",
        fontWeight: 700,
        fontSize: "14px",
        borderTopLeftRadius: "32px",
        borderTopRightRadius: topRightRadius,
        visibility: invisible ? "hidden" : "visible",
      }}
    >
      <LocalOfferOutlinedIcon style={{ fontSize: "18px", flexShrink: 0 }} />
      <span
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          minWidth: 0,
        }}
      >
        {label}
      </span>
    </div>
  );
}
